<template lang="pug">
  .NavigationDrawerMenuItemLink.mobile-item-link(
    :class="{'is--has-children': hasChildren, 'is--not-clickable': !clickable }"
  )
    router-link.mobile-item-link__link(
      v-if="path.startsWith('/') && !newApp",
      :to="path",
      :aria-label="`Click on ${name} link`"
      :class="{'is--active-children': activeChildren}"
    )
      .mobile-item-link__name
        span {{name}}
        slot
    a.mobile-item-link__link(
      v-else-if="newApp"
      :href="path"
      :aria-label="`Click on ${name} link`"
      :class="{'is--active-children': activeChildren}"
    )
      .mobile-item-link__name
        span {{name}}
        slot
    a.mobile-item-link__link(
      v-else
      :href="path"
      target="_blank"
      :aria-label="`Click on ${name} link`"
      :class="{'is--active-children': activeChildren}"
    )
      .mobile-item-link__name
        span {{name}}
</template>

<script>
import NavigationDrawerMenuIcon from './NavigationDrawerMenuIcon';

export default {
  name: 'NavigationDrawerMenuItemLink',
  components: {
    NavigationDrawerMenuIcon,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
    },
    slug: String,
    clickable: {
      type: Boolean,
      default: true,
    },
    newApp: Boolean,
    hasChildren: Boolean,
    activeChildren: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.mobile-item-link
  font-size: 12px
  display: flex
  flex-direction: row
  align-items: center
  position: relative
  transition: none
  &:after
    content: ''
    position: absolute
    right: 0
    bottom: 0
    width: 100%
    height: 2px
    border-bottom: 1px solid $mercury
  &__link
    display: flex
    font-size: inherit
    align-items: center
    width: 100%
    // height: 63px
    padding: 20px 0
  &__name
    width: 100%
    position: relative
    z-index: 2
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    line-height: 22px
    font-size: 16px
  &.is--has-children
    .mobile-item-link__link
      padding-bottom: 8px
    &:after
      display: none

  &.is--not-clickable
    pointer-events: none
</style>
